import { render, staticRenderFns } from "./detail-management.vue?vue&type=template&id=355ae465&scoped=true&"
import script from "./detail-management.vue?vue&type=script&lang=js&"
export * from "./detail-management.vue?vue&type=script&lang=js&"
import style0 from "./detail-management.vue?vue&type=style&index=0&id=355ae465&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ae465",
  null
  
)

export default component.exports